export default __webpack_public_path__ + "static/media/correspondent15.b4f3f363.png";